import { AxiosError } from "axios";
import http from "infra/http";
import { useQuery } from "react-query";
import { RelatorioTenantInfo } from 'core/features/relatorios/typings';

export function useTenantInfo(enabled?: boolean) {
  return useQuery<RelatorioTenantInfo, AxiosError>(
    [`/v1/relatorios/shared/pdf/tenant-info`],
    async () => {
      const { data } = await http.get<RelatorioTenantInfo>(
        `/v1/relatorios/shared/pdf/tenant-info`
      );

      return data;
    }, {
      enabled,
    }
  );
}
